import { emptySplitApi as api } from "./emptyApi";

type SubmittedTrackResponse = {
  data: any[];     // Replace 'any' with your Track type
  total: number;
};

const injectedRtkApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getArtistList: builder.query<[], Partial<ArtistListApiArg>>({
      query: (queryArg) => {
        return {
          url: `/api/artists/songs`,
          params: queryArg,
        };
      },
    }),
    getTrackById: builder.query<SubmittedTrackResponse, Partial<ArtistListApiArg>>({
      query: (queryArg) => {
        return {
          url: `/api/artists/submitted-track`,
          params: queryArg,
        };
      },
    }),
    createTrack: builder.mutation<any, ArtistListApiArg>({
      query: (queryArg) => {
        return {
          url: `/api/artists/submit-songs`,
          method: "POST",
          body: queryArg,
        };
      },
    }),
    checkBannedArtist: builder.query<{ isBanned: boolean; artist: any }, { artistId: string }>({
      query: ({ artistId }) => {
        return {
          url: `/api/artists/check-banned-artist`,
          params: { artistId },
        };
      },
    }),
  }),
});
export { injectedRtkApi as enhancedApi };
export type ArtistListApiArg = {
  trackId?: string;
  playlistIds?: any;
  id?: any;
  userId?: any;
  limit?: any;
  skip?: any;
  isAIGenerated?: boolean;
  genres?: string[];
};
export const {
  useGetArtistListQuery,
  useLazyGetArtistListQuery,
  useGetTrackByIdQuery,
  useCreateTrackMutation,
  useCheckBannedArtistQuery,
  useLazyCheckBannedArtistQuery,
} = injectedRtkApi;
